export default "__VITE_ASSET__0f64ce88__"